import { observer } from 'mobx-react-lite';

import { DrillingElementColoredCard } from '../../../../drilling-element-colored-card';
import type { TemporaryWellRigOperation } from '../../../presets/drilling-rigs-chart/entities';
import type { RigsViewSettingsProvider } from '../../../presets/drilling-rigs-chart/rigs-view-settings-provider';
import { useMovableElement } from '../../../shared/use-movable-element';
import type { Viewport } from '../../../shared/viewport/viewport';

import styles from './data-items-full.module.scss';

interface Props {
  item: TemporaryWellRigOperation;
  horizontalViewport: Viewport;
  verticalViewport: Viewport;
  viewSettingsProvider: RigsViewSettingsProvider;
}

export const TemporaryWellRigOperationWrapper = observer(function TemporaryWellRigOperationWrapper({
  item,
  horizontalViewport,
  verticalViewport,
  viewSettingsProvider,
}: Props) {
  const ref = useMovableElement({
    item,
    horizontalViewport,
    verticalViewport,
  });

  const wellIcon = viewSettingsProvider.getWellIcon(item.data);

  return (
    <div ref={ref} className={styles.dataItem}>
      <DrillingElementColoredCard
        title={viewSettingsProvider.getTitle(item)}
        color={viewSettingsProvider.getWellColor(item) || ''}
        attributes={viewSettingsProvider.getAttributes(item)}
        className={styles.wellCard}
      />
    </div>
  );
});
